import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import set from "@rill/set";
import isEmpty from "lodash/isEmpty";
import loadStripeCard, { getSourceValues } from "../../../utils/stripe-card";
import SettingsNav from "../../../parts/settings-nav";
import CancelAccountModal from "../../../parts/modals/cancel-account";
import UpdatePaymentModal from "../../../parts/modals/update-payment";
import StripeCardComponent from "../../../parts/StripeCardComponent";
import submit from "submit-form";

import UpgradeConfirmationModal from "../../../parts/modals/upgrade-confirmation";
import { US_STATES, AU_STATES } from "../../../constants";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";
import SvgIcon from "../../../parts/SvgIcon";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const FORM_ID = "billing-card-address-details";

class BillingDetails extends React.Component {
  constructor(props) {
    super(props);
    const { activeUserToRequest } = props;
    this.state = {
      editCreditInfo: false,
      countrySelected:
        activeUserToRequest?.coachingBilling?.stripe?.address_country ??
        activeUserToRequest?.country,
      stateSelected:
        activeUserToRequest?.coachingBilling?.stripe?.address_state ?? "",
    };

    this.handleCreditToggle = this.handleCreditToggle.bind(this);
  }

  componentDidMount() {
    loadStripeCard(FORM_ID, this.stripeTokenHandler);
  }

  stripeTokenHandler(res) {
    submit("/actions/coach-billing/update/source", {
      method: "POST",
      body: {
        source: getSourceValues(),
        stripeToken: res,
      },
    });
  }

  handleCreditToggle() {
    this.setState({ editCreditInfo: !this.state.editCreditInfo }, () => {
      loadStripeCard(FORM_ID, this.stripeTokenHandler);
    });
  }

  handleCountrySelect(e) {
    this.setState({ countrySelected: e.target.value });
  }
  handleStateSelect(e) {
    this.setState({ stateSelected: e.target.value });
  }

  render() {
    const { locals, req } = this.context;
    const {
      activeUser,
      getCountryName,
      countries: countryOptions,
      activeUserToRequest,
    } = locals;
    const { countrySelected, stateSelected, editCreditInfo } = this.state;
    const stripe = get(activeUserToRequest, "coachingBilling.stripe", {});
    const cardType =
      activeUserToRequest &&
      activeUserToRequest.coachingBilling &&
      activeUserToRequest.coachingBilling.stripe &&
      activeUserToRequest.coachingBilling.stripe.brand
        ? activeUserToRequest.coachingBilling.stripe.brand
            .replace(" ", "-")
            .toLowerCase()
        : null;
    const { address_line1, address_line2, address_city, address_zip } = stripe
      ? stripe
      : {};
    const addressLine2Render = address_line2 === null ? "" : address_line2;

    return (
      <main className="settings manage-billing">
        <SettingsNav classNames="mobile-hidden" />
        <form
          method="POST"
          action="/actions/coach-billing/update/source"
          id={FORM_ID}
          className="manage-billing"
        >
          <h3 className="force-mobile-hidden">Manage Billing</h3>
          <SettingsBackHandler title={"Manage Billing"} />
          <p className="s2 -mt-4 mb-8">
            Manage the card you have on file for billing of your PULL (coaching)
            account.
          </p>
          {isEmpty(stripe) ? (
            <div role="input-group">
              <label htmlFor="card-element">Credit card information</label>
              <StripeCardComponent />
            </div>
          ) : !editCreditInfo || req.query.closeEditCredit ? (
            <div className="payment-details">
              <label>Your Payment Details</label>
              <div className="card-details">
                <SvgIcon
                  className="cc-brand"
                  src={`/img/${cardType}-icon.svg`}
                />
                <strong>**** **** **** ${stripe.last4}</strong>
                <a
                  role="button"
                  data-button-type="text"
                  href=""
                  onClick={this.handleCreditToggle}
                >
                  <span>Change Card</span>
                </a>
              </div>
            </div>
          ) : null}

          <div className="stripe-info">
            {editCreditInfo && !req.query.closeEditCredit && (
              <div role="input-group">
                <label htmlFor="card-element">Credit card information</label>
                <StripeCardComponent />
              </div>
            )}
          </div>

          <section>
            <div className="input-group">
              <label htmlFor="source[address_line1]">Billing Address</label>
              <input
                className="text-input"
                name="source[address_line1]"
                type="text"
                placeholder="Address Line 1"
                defaultValue={address_line1}
                sz="large"
              />
            </div>

            <div className="input-group">
              <label htmlFor="source[address_line2]">&nbsp;</label>
              <input
                className="text-input"
                name="source[address_line2]"
                type="text"
                placeholder="Address Line 2"
                defaultValue={addressLine2Render}
                sz="large"
              />
            </div>

            <div role="input-group">
              <label htmlFor="source[address_city]">City</label>
              <input
                className="text-input"
                name="source[address_city]"
                type="text"
                placeholder="City"
                defaultValue={address_city}
                sz="large"
              />
            </div>

            <div role="input-group">
              <label htmlFor="source[address_country]">Country</label>
              <select
                required
                name="source[address_country]"
                className="select-input"
                value={
                  countrySelected
                    ? countrySelected
                    : get(activeUser, "country", "")
                }
                onChange={(e) => this.handleCountrySelect(e)}
                sz="large"
              >
                <option hidden disabled value="">
                  Location
                </option>
                {map(countryOptions, (code) => {
                  return (
                    <option key={code} value={code}>
                      {getCountryName(code)}
                    </option>
                  );
                })}
              </select>
            </div>

            {["AU", "CA", "US"].indexOf(countrySelected) == -1 && (
              <div role="input-group">
                <label htmlFor="source[address_state]">State</label>
                <input
                  className="text-input"
                  name="source[address_state]"
                  type="text"
                  placeholder="State"
                  value={stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                  sz="large"
                />
              </div>
            )}

            {countrySelected === "CA" && (
              <div role="input-group">
                <label htmlFor="source[address_state]">Province</label>
                <select
                  className="select-input"
                  name="source[address_state]"
                  placeholder="Province"
                  value={stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                  sz="large"
                >
                  <option disabled value="">
                    Province
                  </option>
                  <option value="AB">Alberta</option>
                  <option value="BC">British Columbia</option>
                  <option value="MB">Manitoba</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NL">Newfoundland and Labrador</option>
                  <option value="NS">Nova Scotia</option>
                  <option value="ON">Ontario</option>
                  <option value="PE">Prince Edward Island</option>
                  <option value="QC">Quebec</option>
                  <option value="SK">Saskatchewan</option>
                  <option value="NT">Northwest Territories</option>
                  <option value="NU">Nunavut</option>
                  <option value="YT">Yukon</option>
                </select>
              </div>
            )}

            {countrySelected === "US" && (
              <div role="input-group">
                <label htmlFor="source[address_state]">State</label>
                <select
                  className="select-input"
                  type="text"
                  name="source[address_state]"
                  value={stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                  sz="large"
                >
                  <option disabled value="">
                    State
                  </option>
                  {US_STATES.map((state) => (
                    <option value={state.abbreviation}>{state.name}</option>
                  ))}
                </select>
              </div>
            )}

            {countrySelected === "AU" && (
              <div role="input-group">
                <label htmlFor="source[address_state]">State</label>
                <select
                  className="select-input"
                  type="text"
                  name="source[address_state]"
                  value={stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                  sz="large"
                >
                  <option disabled value="">
                    State
                  </option>
                  {AU_STATES.map((state) => (
                    <option value={state.abbreviation}>{state.name}</option>
                  ))}
                </select>
              </div>
            )}

            <div role="input-group">
              <label htmlFor="source[address_zip]">
                {countrySelected === "US" ? "Zip Code" : "Postal Code"}
              </label>
              <input
                className="text-input"
                name="source[address_zip]"
                type="text"
                placeholder={
                  countrySelected === "US" ? "Zip Code" : "Postal Code"
                }
                defaultValue={address_zip}
                sz="large"
              />
            </div>
          </section>

          <button type="submit" data-button-type="primary">
            Save
          </button>
        </form>
      </main>
    );
  }
}

const BillingDetailsController = (app) => {
  app.get(
    "/coach-manage-billing",
    set("heading", "Manage Billing"),
    (ctx, next) =>
      checkOrganizationSectionPermission(
        ctx,
        next,
        "settings",
        "/coaching-portal/settings",
        ["Owner"]
      ),
    ({ res, req, locals, session }) => {
      const { query } = req;

      const modal = get(query, "modal", {});
      locals.modal = {
        cancel: <CancelAccountModal />,
        "update-payment": <UpdatePaymentModal />,
        "upgrade-confirmation": <UpgradeConfirmationModal />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = (
        <BillingDetails
          activeUser={locals.activeUser}
          show
          stripe={query.action == "update stripe" ? true : false}
          activeUserToRequest={locals.activeUserToRequest}
        />
      );
    }
  );
};

export default BillingDetailsController;
